// extracted by mini-css-extract-plugin
export default {"wrapper":"apis_wrapper__9QDr-","sidebar":"apis_sidebar__DlKn-","ant-menu-inline":"apis_ant-menu-inline__PbNes","container":"apis_container__xBKNQ"};